import { useTranslation } from 'react-i18next';
import { useStore } from '../../store/database';
import { TIER_LABELS } from '../../config/house.config';
import type { SupportedLang } from '../../config/house.config';

export default function EventsPage() {
  const { t, i18n } = useTranslation();
  const events = useStore(s => s.events.filter(e => e.is_published && !e.deleted_at));
  const lang = i18n.language as SupportedLang;

  return (
    <div className="space-y-6">
      <h1 className="font-serif text-2xl tracking-widest">{t('events.title')}</h1>
      {events.length === 0 && <p className="text-sm text-charcoal/50 font-sans">{t('events.noEvents')}</p>}
      <div className="space-y-4">
        {events.sort((a, b) => a.event_date.localeCompare(b.event_date)).map(e => {
          const tr = e.translations[lang] || e.translations.en;
          return (
            <div key={e.id} className="border border-charcoal/5 p-6">
              <h2 className="font-serif text-xl">{tr.title}</h2>
              <p className="text-sm font-sans text-charcoal/70 mt-2 leading-relaxed">{tr.content}</p>
              <div className="flex items-center gap-4 mt-3 text-[10px] text-charcoal/40 font-sans">
                <span>{t('events.date')}: {new Date(e.event_date).toLocaleDateString()}</span>
                <span>{t('events.location')}: {e.location}</span>
                <span>{t('events.tierRequired', { tier: TIER_LABELS[e.min_tier] })}</span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
